import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  FormGroup,
  List,
  Tooltip,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import ColumnGroupIcon from "assets/images/icons/column-group.svg";
import { useBoundStore } from "useStore";
import LightTooltip from "views/Components/Shared/Components/LightTooltip";
import { COLUMNS_TO_FILTER } from "./utils";
import { useState } from "react";

function Options({ closeTooltip }) {
  const columns = useBoundStore((state) => state.productMasterColumns);
  const toggleColumns = useBoundStore(
    (state) => state.toggleProductMasterColumns
  );

  const handleChange = (e) => {
    const { name, checked } = e.target;
    toggleColumns(name, checked);
  };

  const selectedColumns = COLUMNS_TO_FILTER.map((col) => columns[col.data]);
  const selectedCount = selectedColumns.filter(Boolean).length;

  const isAllColumnsSelected = selectedCount === selectedColumns.length;
  //   const isNoneSelected = selectedCount === 0;
  const isIndeterminate = !isAllColumnsSelected; 

  const isCheckboxChecked = isAllColumnsSelected;

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    columns.forEach((column) => {
      toggleColumns(column.data, isChecked);
    });
  };

  return (
    <List
      sx={{ width: "340px", maxWidth: 340, bgcolor: "background.paper" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={isCheckboxChecked}
                indeterminate={isIndeterminate}
                onChange={handleSelectAll}
              />
            }
            label={
              <Typography
                sx={{
                  pl: 2,
                  color: "rgba(0, 0, 0, 0.87)",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "700",
                  letterSpacing: "0.15px",
                  padding: "12px",
                }}
              >
                Filtrar columnas:
              </Typography>
            }
          />
        </Stack>
      }
    >
      <Divider />

      <List component="div" disablePadding>
        <Box
          sx={{
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          <FormGroup sx={{ pl: 2 }}>
            {COLUMNS_TO_FILTER.map((column) => (
              <Box key={column.data}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="secondary"
                      name={column.data}
                      checked={columns[column.data]}
                      onChange={handleChange}
                    />
                  }
                  label={column.label}
                />

                <Divider />
              </Box>
            ))}
          </FormGroup>
        </Box>
      </List>

      <Button
        color="secondary"
        onClick={closeTooltip}
        sx={{
          mt: 1,
        }}
      >
        CERRAR
      </Button>
    </List>
  );
}

export default function FiltersColumns() {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleToggleTooltip = () => {
    setOpen((prev) => !prev);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div style={{ display: "inline-block" }}>
        <LightTooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={<Options closeTooltip={handleTooltipClose} />}
        >
          <div style={{ display: "inline-block" }}>
            <Tooltip title="Customizar Tabla" placement="bottom" arrow>
              <Box>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    padding: "8px",
                    width: "60px",
                    height: "50px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    border: "1px solid rgba(53, 72, 135, 1)",
                  }}
                  onClick={handleToggleTooltip}
                >
                  <img
                    src={ColumnGroupIcon}
                    alt="Icono de columnas"
                    style={{
                      width: "24px",
                      height: "24px",
                    }}
                  />
                </Stack>
              </Box>
            </Tooltip>
          </div>
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}
